import React from 'react'
import leftarrow from "../../../assets/images/left-arrow.svg";
import styles from './passwordSuccess.module.css';
import { Trans, useTranslation } from "react-i18next";
import { Footer } from '../../common/footer/footer';
const PassSuccessJsx = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <section className="mainloginscreen">
        <div className="container">
         
        <div className={`${styles.mainloginscreeninner}`}>
        <div className={`${styles.leftsightbackdetails} d-flex`}>
        <div className="d-flex plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => props.onBackClick()}><img src={leftarrow} alt={'icon'} /></div>
               
                  <h1>{t("PASSWORDAUTHORIZATION.Success_message")}</h1>
                 
                </div>
              </div>
            </div>
            <div className={`${styles.formsection}`}>
            <div className={`${styles.institutelogintext}`}>
                <div className="forgetpassinner">
                  <h2 className="h2_style">{t("PASSWORDAUTHORIZATION.Congratulations")}</h2>
                  <h4><Trans>{t("PASSWORDAUTHORIZATION.Successfull_message")}</Trans></h4>
                  {/* <h4>{t("PASSWORDAUTHORIZATION.Login_again")}</h4> */}
                  <div className="ft-inner otpauthentication">
                  <div className="d-flex align-items-center justify-content-center"> <button type="submit" className="mt-3 mb-4 mainbutton" onClick={() => props.handleSubmit()}>Login</button>
                  </div>
                  </div>
                </div>
              </div>
            </div>
         <Footer/>
        </div>
      </section>

    </>

  );
};

export default PassSuccessJsx;
